import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _16mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"16mp"} ref={ref}/>
});

_16mpIcon.displayName = "_16mpIcon";
